<template>
  <section role="modal">
    <div
      class="modal fade"
      id="encerramentoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="encerramentoModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="encerramentoModalLabel">
              Atualização  do CPF do Familiar
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px;">
              <div class="col-md-12 col-sm-12 aviso-inicial">
                "Conforme portaria 06/2022-SEGES, o recadastramento encerrou dia 05/08/2022.
                Excepcionalmente, será permitido que os servidores atualizem os dados até 23:59 do dia 07/08/2022"
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              estilo="cheio-verde"
              rotulo="Entendi"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from "@/components/botao";

export default {
  name: "EncerramentoModal",

  components: {
    Botao,
  },
};
</script>

<style scoped>
  .aviso-inicial {
    font-size: 1.1em;
    font-weight: bolder;
    color: #FF3C3C;
    text-align: justify;
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// encerramento-modal.vue?65eb2bb5